import ModificationLogTypes from './types';

const initialState = {
    modificationLog: { data: [] },
    fetchingModificationLog: false,
    error: null
};

function modificationLogReducer( state = initialState, { type, payload }) {
    switch (type) {
        case ModificationLogTypes.FETCH_MODIFICATION_LOG_START:
            return {
                ...state,
                fetchingModificationLog: true,
            };
        case ModificationLogTypes.FETCH_MODIFICATION_LOG_SUCCESS:
            return {
                ...state,
                fetchingModificationLog: false,
                modificationLog: payload,
            };
        case ModificationLogTypes.FETCH_MODIFICATION_LOG_FAILURE:
            return {
                ...state,
                fetchingModificationLog: false,
                error: payload
            };
        default:
            return state;
    }
}

export default modificationLogReducer;